export const IS_DEV = process.env.NODE_ENV !== 'production';
export const STAGE: 'alpha' | 'prod' = IS_DEV ? 'alpha' : import.meta.env.VITE_STAGE || 'prod';

const stageApiUrl = {
  prod: 'https://soongpt-api.yourssu.com/api',
  alpha: 'https://soongpt-dev-api.yourssu.com/api',
}[STAGE];

export const config = {
  apiUrl:
    ((STAGE == 'alpha' ? `${window.location.origin}/api` : undefined) ||
      import.meta.env.VITE_API_URL) ??
    stageApiUrl,
};
